import axios from 'axios';
import React, { useEffect, useContext, useState } from 'react';
import { SpinnerDotted } from 'spinners-react';
import { TableContext } from '../../contexts/tableContext';
// import { REACT_APP_API_FETCH_USER } from '../../redux/apiConstants';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import styles from './index.module.scss';
// import { getCookies } from '../../hooks/useCookies';
import CustomTable from '../../components/CustomTable/CustomTable';

export default function UserIndex() {
  let response;
  let url;
  // const token = `Bearer ${getCookies('Token')}`;
  let statusCode;
  const [data, setData] = useState([]);
  const { setTableLoading, pageNum, sorting, search, deletedData, setDashboardHeader } =
    useContext(TableContext);
  const dataPerPage = 4;

  const getUsers = async () => {
    setTableLoading(true);
    url = 'http://localhost:4036/v1/user?';
    if (search == null) {
      url += `page=${pageNum}&limit=${dataPerPage}`;
    }
    if (sorting.sortType && sorting.sortType !== 'none') {
      url += `&sortBy=${sorting.col}:${sorting.sortType}`;
    }
    if (search !== null) {
      url += `&searchBy=${search}`;
    }
    axios
      .get(url, {
        method: 'GET',
        // headers: { Authorization: token },
      })
      .then((resp) => {
        setTableLoading(false);
        statusCode = resp.status;
        return resp;
      })
      .then((res) => {
        if (statusCode === 200) {
          console.log(res);
          response = res.data.data.result;
          setData(response);
        }
      })
      .catch((err) => {
        setTableLoading(false);
        console.log(err);
        return err;
      });
  };
  useEffect(() => {
    getUsers();
    setDashboardHeader('User');
  }, [search, sorting, pageNum, deletedData]);
  return (
    <div className={styles.indexdiv}>
      {Object.keys(data).length > 0 ? (
        <CustomTable
          data={data}
          viewPopUp
          section="user"
          toggleButton={{ show: true, field: 'active' }}
          deleteCondition={{ checkCondition: false, apiUrl: 'www.google.com' }}
        />
      ) : (
        <SpinnerDotted style={{ marginLeft: '650px', marginTop: '200px', color: '#39979d' }} />
      )}
    </div>
  );
}
